// Aviso de versión web nueva (retro 2026-08-01: la app retenía el build viejo
// incluso con cierre forzado). Compara el sello del bundle (__WEB_BUILD__)
// contra /build.json del servidor al arrancar, al volver a primer plano y cada
// 10 min; si difieren, muestra el botón "Actualizar" que recarga la página.
import { useEffect, useState } from 'react'

export function WebUpdateBanner() {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    let cancelled = false
    const check = async () => {
      try {
        const r = await fetch('/build.json', { cache: 'no-store' })
        if (!r.ok) return
        const { build } = (await r.json()) as { build?: string }
        if (!cancelled && build && build !== __WEB_BUILD__) setAvailable(true)
      } catch {
        /* sin red: se reintenta en el siguiente ciclo */
      }
    }
    check()
    const onVisible = () => document.visibilityState === 'visible' && check()
    document.addEventListener('visibilitychange', onVisible)
    const t = setInterval(check, 10 * 60 * 1000)
    return () => {
      cancelled = true
      document.removeEventListener('visibilitychange', onVisible)
      clearInterval(t)
    }
  }, [])

  if (!available) return null
  return (
    <div className="fixed inset-x-3 bottom-4 z-50 flex items-center justify-between gap-3 rounded-2xl border border-ds-200 bg-white p-3 shadow-cardhover sm:left-auto sm:right-4 sm:w-96">
      <p className="min-w-0 text-sm text-gray-700">
        🔄 Hay una versión nueva de Hotel Depot Reparto lista.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="shrink-0 rounded-lg bg-ds-500 px-4 py-2 text-sm font-semibold text-white hover:bg-ds-700"
      >
        Actualizar
      </button>
    </div>
  )
}
